/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container } from 'reactstrap';
import Swal from 'sweetalert2';
import Select from 'react-select';

import { getPermissions, addPermissions, updatePermissions, deletePermissions } from '../../../store/Permissions/actions';

import Breadcrumbs from '../../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import FormPermissions from './form-Permissions';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';

import { getClients } from '../../../store/actions';
import usePageTitle from '../../../common/hooks/usePageTitle';

const PermissionsList = (props: any) => {
    const dispatch = useDispatch();
    const { permissions } = useSelector((state: any) => state.Permissions);

    const PageTitleVI = usePageTitle(props.location.pathname);

    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [permissionsData, SetPermissionsData] = useState<any>([]);
    const [permissionsParents, SetPermissionsParents] = useState<any>([]);

    useEffect(() => {
        SetPermissionsData(formatDataPermissions());
    }, [permissions])

    const valuesSizePagination = [10, 20, 30, 40, 50, 100];
    const [pagination, setPagination] = useState<any>({
        sizePerPage: valuesSizePagination[0],
        page: 1,
    });

    const initialArrayTable = [
        {
            text: 'ID',
            dataField: 'id',
            formatter: (cellContent: any, permissions: any) => <>{permissions.id}</>,
            hidden: true,
        },
        {
            text: 'padreId',
            dataField: 'padreId',
            formatter: (cellContent: any, permissions: any) => <>{permissions.padreId}</>,
            hidden: false,
        },
        {
            text: 'Identificator',
            dataField: 'identificator',
            formatter: (cellContent: any, permissions: any) => <>{permissions.identificator}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'nombre',
            formatter: (cellContent: any, permissions: any) => <>{permissions.nombre}</>,
            hidden: false,
        },
        {
            text: 'Description',
            dataField: 'descripcion',
            formatter: (cellContent: any, permissions: any) => <>{permissions.descripcion}</>,
            hidden: false,
        },
        {
            text: 'Url',
            dataField: 'url_menu',
            formatter: (cellContent: any, permissions: any) => <>{permissions.url_menu}</>,
            hidden: false,
        },
        {
            text: 'Icon',
            dataField: 'icon',
            formatter: (cellContent: any, permissions: any) => <>{permissions.icon}</>,
            hidden: false,
        },
        {
            text: 'MCA_ACTIVO',
            dataField: 'MCA_ACTIVO',
            formatter: (cellContent: any, permissions: any) => {
                return (
                    <ISwitch
                        checked={permissions.MCA_ACTIVO}
                        onChangeBooleanHandler={(args) => {
                            const newObject = { ...permissions };
                            newObject.MCA_ACTIVO = args;
                            dispatch(updatePermissions({ permission: newObject, pagination }));
                        }}
                    />
                );
            },
            hidden: false,
        },
        {
            text: 'EMPRESA_ID',
            dataField: 'EMPRESA_ID',
            formatter: (cellContent: any, permissions: any) => <>{permissions.EMPRESA_ID}</>,
            hidden: true,
        },
        {
            text: 'IDIOMA_ID',
            dataField: 'IDIOMA_ID',
            formatter: (cellContent: any, permissions: any) => <>{permissions.IDIOMA_ID}</>,
            hidden: true,
        },
        {
            text: 'applicationId',
            dataField: 'applicationId',
            formatter: (cellContent: any, permissions: any) => <>{permissions.applicationId}</>,
            hidden: true,
        },
        {
            text: 'Order',
            dataField: 'orden',
            formatter: (cellContent: any, permissions: any) => <>{permissions.orden}</>,
            hidden: false,
        },
        {
            text: 'createdAt',
            dataField: 'createdAt',
            formatter: (cellContent: any, permissions: any) => <>{permissions.createdAt}</>,
            hidden: true,
        },
        {
            text: 'updatedAt',
            dataField: 'updatedAt',
            formatter: (cellContent: any, permissions: any) => <>{permissions.updatedAt}</>,
            hidden: true,
        },
        {
            text: 'padreId',
            dataField: 'padreId',
            formatter: (cellContent: any, permissions: any) => <>{permissions.padreId}</>,
            hidden: true,
        },
    ];

    function getParents(items:any) {
        const padresIds = new Set(items.map((item:any) => item.padreId).filter((id:any) => id !== null));
        const padres = items.filter((item:any) => padresIds.has(item.id));
      
        return padres;
      }

    const formatDataPermissions = () => {
        const newMap = new Map();
        for (const permission of permissions) {
            let key = "";

            if (permission.identificator === "Standard") key = `${permission.nombre}-${permission.descripcion}-${permission.url_menu}-${permission.generic}-${permission.excludedClientIds}`;
            if (permission.identificator === "Holistics") key = `${permission.nombre}-${permission.URL}-${permission.HolisticsClientIdentificator}-${permission.ClientSecret}-${permission.generic}-${permission.excludedClientIds}`;
            if (permission.identificator === "iFrame") key = `${permission.nombre}-${permission.Code}-${permission.generic}-${permission.excludedClientIds}`;
            if (newMap.has(key)) {
                const existing = newMap.get(key);
                if (Array.isArray(existing.EMPRESA_ID)) {
                    existing.EMPRESA_ID.push(permission.EMPRESA_ID);
                } else existing.EMPRESA_ID = [existing.EMPRESA_ID, permission.EMPRESA_ID];
                if (Array.isArray(existing.id)) {
                    existing.id.push(permission.id);
                } else existing.id = [existing.id, permission.id];
            } else newMap.set(key, { ...permission, id: [permission.id], EMPRESA_ID: [permission.EMPRESA_ID] });
        }
        const newArray = Array.from(newMap.values())
        return newArray.sort((a: any, b: any) => a.nombre - b.nombre);
    }

    const handleCreatePermissions = (permission: any) => {
        setpopUpState(!popUpState);
        dispatch(addPermissions({ permission, pagination }));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
    };

    const handleUpdatePermissions = (permission: any) => {
        setpopUpState(!popUpState);
        dispatch(updatePermissions({ permission, pagination }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        });
    };

    const handleCancel = () => {
        setpopUpState(!popUpState);
    };

    const handleDeletePermissions = (id: any) => {
        setpopUpState(!popUpState);
        dispatch(deletePermissions({ id, pagination }));
        Swal.fire({
            icon: 'success',
            title: 'Deleted!!!',
            text: 'Items have been deleted successfully!!!',
        });
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        if (!Array.isArray(row.excludedClientIds)) {
            row.excludedClientIds = JSON.parse(row.excludedClientIds);
            if (row.excludedClientIds === "") row.excludedClientIds = []
        }
        if (!Array.isArray(row.excludedRoles)) {
            row.excludedRoles = JSON.parse(row.excludedRoles ?? "[]");
            if (row.excludedRoles === "") row.excludedRoles = []
        }
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    useEffect(() => {
        dispatch(getClients({}));
    }, [dispatch]);

    const { clients } = useSelector((state: any) => state.clients);

    const valuesSizeClientsPagination = [10, 20, 30, 40, 50, 100];
    const [, setPaginationClients] = useState<any>({
        sizePerPage: valuesSizeClientsPagination[0],
        page: 1,
    });

    const [order, setOrder] = useState("{ 'createdAt' : 'DESC'}")
    /* Filters */

    const textClient = 'Search Client ID';
    const textPadreID= 'Search PadreID';
    const textName = 'Search Name';
    const textIdentificator = 'Search Identificator';

    const [queryObject, setQueryObject] = useState<any>({});
    const [queryString, setQueryString] = useState<any>({});

    const initialArrayTableClients = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
            hidden: false,
        },
    ];

    const initialArrayTableClients2 = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
            hidden: false,
        },
        {
            text: 'Client ID',
            dataField: 'EMPRESA_ID',
            formatter: (cellContent: any, clients: any) => <>{clients.EMPRESA_ID}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'nombre',
            formatter: (cellContent: any, clients: any) => <>{clients.nombre}</>,
            hidden: false,
        },
    ];

    useEffect(() => {
        dispatch(getPermissions({ order }));
    }, [dispatch, order]);

    useEffect(() => {
        const object = queryObject[textClient]
        const objectParent = queryObject[textPadreID]
        const query = queryString[textName]
        const queryIdentificator = queryString[textIdentificator]
        const permissionsDataClean = [...formatDataPermissions()];
        let newArray = permissionsDataClean;
        if (object) newArray = newArray.filter((item: any) => item.EMPRESA_ID.includes(object?.id));
        if (objectParent) newArray = newArray.filter((item: any) => item.padreId == objectParent?.id);
        if (query) newArray = newArray.filter((item: any) => item.nombre.toLowerCase().includes(query.toLowerCase()));
        if (queryIdentificator && queryIdentificator != "All") newArray = newArray.filter((item: any) => item.identificator.toLowerCase().includes(queryIdentificator.toLowerCase()));
        SetPermissionsData(newArray);
    }, [queryObject, queryString, permissions])

    const handlePaginationClientsChange = (newState: any) => {
        setPaginationClients(newState);
    };
    const onChangeSelectorHandler = (n: any, value: any) => {
        setQueryString({ ...queryString, [n]: value.id });
        setQueryObject({ ...queryObject, [n]: value });
    };

    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setOrder(`{'${sortField}' : '${sortOrder.toUpperCase()}'}`)
    }

    useEffect(() => {
        const parents = getParents(permissions)
        SetPermissionsParents(parents)
    }, [permissions]);

    const onChangeHandler = (e: any, n: any) => {
        if (n === 'Search Client ID') {
            const newObject = clients.find((item: any) => Number(item.id) === Number(e.target.value));
            setQueryObject({ ...queryObject, [n]: newObject });
        }
        if (n === textPadreID) {
            const newObject = permissions.find((item: any) => item.id == e.target.value);
            setQueryObject({ ...queryObject, [n]: newObject });
        }
        setQueryString({ ...queryString, [n]: e.target.value });
    };

    const identificator = ['All', 'Standard', 'Holistics', 'iFrame'];

    const [modalName, setModalName] = useState("Permissions")
    const AdminFilters = () => {
        return (
            <>
                <div className="col-3 h-100 my-2">
                    <div className="">
                        <Select
                            styles={
                                {
                                    input: (provided: any) => ({
                                        ...provided,
                                        height: '48px',    // Altura del área de texto del input
                                    }),
                                }
                            }
                            defaultValue={{ label: 'Select A Identificator' }}
                            onChange={(e: any) => {
                                setQueryString({ ...queryString, [textIdentificator]: e.value });
                            }}
                            options={identificator.map((item: any) => {
                                return { label: item, value: item };
                            })}
                        />
                    </div>
                </div>
                <div className="col-3 my-2">
                    <div className="justify-content-center">
                        <ISelector
                            title={textClient}
                            value={queryObject[textClient]?.id || queryString[textClient] || ''}
                            nameSelector={queryObject[textClient]?.name ?? ''}
                            valuesSizePagination={valuesSizeClientsPagination}
                            CountItems={clients?.length}
                            dataSelector={clients}
                            initialArrayTable={initialArrayTableClients}
                            handlePaginationChange={handlePaginationClientsChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>

                <div className="col-3 my-2">
                    <div className="justify-content-center">
                        <ISelector
                            title={textPadreID}
                            value={queryObject[textPadreID]?.id || queryString[textPadreID] || ''}
                            nameSelector={queryObject[textPadreID]?.name ?? ''}
                            valuesSizePagination={valuesSizeClientsPagination}
                            CountItems={permissionsParents?.length}
                            dataSelector={permissionsParents}
                            initialArrayTable={initialArrayTableClients2}
                            handlePaginationChange={handlePaginationClientsChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="col-3 my-2">
                    <div className="justify-content-center">
                        <IInput title={textName} type={'text'} value={queryString[textName]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
            </>
        );
    };

    return (
        <React.Fragment>
            <div id="main" style={{ overflow: 'auto' }}>
                <div id="navbar"></div>
                <div className="pageContent">
                    <PageTitle>
                        <title>{PageTitleVI.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                    <Container fluid>
                        <div className="row justify-content-center me-2">
                            <div className="d-flex justify-content-end pb-3">
                                <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                                    + Add
                                </button>
                            </div>
                            {AdminFilters()}
                        </div>

                        <Col lg="12">
                            <ITable
                                //CountItems={CountItems}
                                //remote={true}
                                //handlerPaginationState={handlePaginationChange}
                                //valuesSizePagination={valuesSizePagination}
                                data={permissionsData}
                                fields={initialArrayTable}
                                tableColumns={initialArrayTable}
                                headerColorT={'bg-primary text-white'}
                                groupName=""
                                handlePopUpState={onPopUpState}
                                actionOnRowClick={handleActionOnRowClick}
                                handleTableSort={handleTableSort}
                            />
                        </Col>
                    </Container>
                </div>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={modalName}
                modaleTitleUpdate={'Update Permissions'}
                icon="users"
                colorHeaderPop={'#101340'}
                height="800px"
                width="900px"
            >
                <FormPermissions
                    selectedRow={selectedRow}
                    onCreatePermission={handleCreatePermissions}
                    onUpdatePermission={handleUpdatePermissions}
                    onDeletePermission={handleDeletePermissions}
                    modalName={setModalName}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default PermissionsList;
